// GH-681 — "מה השתנה בגרסה", בשפה של בני אדם. קובץ טקסט, לא DB: בכל העלאת גרסה מוסיפים בלוק
// למעלה (קלוד עושה את זה כשאורי אומר "מעלה X"), וזה עולה עם ה-deploy של האדמין. החדש ראשון.
export type Release = {
	version: string;
	date: string; // YYYY-MM-DD
	platforms: ('mobile' | 'web' | 'backend' | 'admin' | 'experts')[];
	users: string[]; // למשתמשים
	hr: string[]; // ל-HR ולאדמין
	tech: string[]; // טכני / פנימי
	tickets: [string, string][]; // [GH-key, כותרת]
};

export const releases: Release[] = [
	{
		version: '2.4.0 (בעבודה)',
		date: '2026-10-21',
		platforms: [],
		users: [],
		hr: [],
		tech: [],
		tickets: [],
	},
	{
		version: '2.3.9',
		date: '2026-10-21',
		platforms: ['mobile', 'web', 'backend', 'admin'],
		users: [
			'אנדרואיד: חיבור השעון (Health Connect: למשל Samsung Health, Fitbit, Garmin) מגיע לאנדרואיד בגרסה הזו. גרסה 2.3.8 לא פורסמה ב-Google Play, ולכן משתמשי אנדרואיד נשארו עד עכשיו על 2.3.7.',
			'הכרטיס "הולכים עם שעון?" מופיע מיד אחרי שמאשרים את הרשאת הצעדים, בלי לצאת מהמסך ולחזור. הוסר ממנו המשפט "צעדים שהוזנו ידנית לא נספרים".',
			'אתגר הצעדים האוטונומי (לא מכבי): הוסר הכיתוב "עדיין לא זכאי/ת" מהשורות של "הקבוצה שלכם".',
			'מכבי: הציון בתחרות מחושב לפי המסמך של מכבי.',
			'מכבי, השתתפות: מספר הנרשמים מתוך מצבת העובדים של היחידה.',
			'מכבי, תנועה: ממוצע הצעדים ליום הליכה של היחידה, בלי איזון מול הממוצע הכללי. מעל היעד של 10,000 צעדים יש בונוס, עד 150%.',
			'מכבי, התמדה: ימי ההליכה מתוך כל הימים מתחילת התחרות.',
			'מכבי: התחרות מסתיימת ב-20.12.2026.',
			'מכבי: הדירוג מתעדכן כל חצי שעה, במקום כל שלוש שעות. באתר כבר כתוב "כל חצי שעה". באפליקציה עדיין כתוב "אחת לכמה שעות", וזה יתוקן בגרסה הבאה.',
			'Cellebrite, יום אירוע: עמוד מומחה ייעודי באתר, עם יומן שפתוח רק לעובדי Cellebrite ביום האירוע. כרגע המומחה והתאריך (3.12) זמניים, עד שהמומחה האמיתי ייווצר.',
		],
		hr: [
			'דשבורד התחרות: בטולטיפ של הציון מופיעים עכשיו המספרים שמאחורי האחוזים. בהשתתפות: "144 מתוך 659".',
			'בהתמדה: "113 ימי הליכה מתוך 144 אפשריים".',
			'בתנועה: "מעל היעד 10,000 → 131% (בונוס)" ו"תקרת הבונוס 150%".',
			'שורת "אחרי ריכוך" מופיעה רק כשהריכוך דלוק.',
			'מכבי: גדלי היחידות עודכנו לפי הקובץ של הדר מ-19.10: 8 מחוזות ו-92 יחידות, בשלוש ליגות (29/32/31).',
			'מכבי: "חטיבת תפעול מכבי פארם" נקראת עכשיו "מנהלת מכבי פארם".',
			'מכבי: תחרות הצעדים נפתחה ב-21.10, עם איפוס בלילה והודעת פתיחה ב-07:00.',
			'שותפים (ספקים): נוסף איש קשר לקשר שוטף (שם פרטי, שם משפחה ונייד), באשף ההצטרפות ובעמוד "העסק שלי".',
			'שותפים (ספקים): בעמוד השותפים באדמין נוספה עמודת "איש קשר".',
			'שותפים (ספקים): בהצטרפות אפשר להעלות רק תמונות ו-PDF.',
		],
		tech: [
			'GH-825, שדות חדשים ב-Competition: movement_cap (ברירת מחדל 1; 0 או null = בלי תקרה), persistence_from_start (ברירת מחדל false), ו-persistence_window (מחרוזת פתוחה, ברירת מחדל elapsed).',
			'GH-825: ברירות המחדל שומרות על ההתנהגות הקודמת, כך שבתחרויות אחרות לא השתנה כלום.',
			'GH-825: נוסף previewScores לקריאה בלבד, ונוסף eligible_participant_days לשורות של היחידות.',
			'GH-825: את ההגדרות של מכבי שמר הסקריפט gh825-maccabi-scoring-settings.ts, שאורי הריץ בפרוד. הערכים הקודמים והדרך לחזור אליהם מתועדים ב-GH-825.',
			'קרון הניקוד: \'10,40 * * * *\' (היה \'15 */3 * * *\'). ריצה אחת לוקחת כ-2 שניות עם 1,221 משתתפים.',
			'התראת הפודיום משווה עכשיו לדירוג מלפני 20 שעות לפחות. עם ניקוד כל חצי שעה, ההשוואה לריצה הקודמת לא הייתה נשלחת אף פעם.',
			'GH-823: נוסף isEventDayBooking(). הוא מדלג על בדיקת המנוי רק בהזמנה שתואמת בדיוק שורת אירוע (מומחה, שירות, תאריך וחברה). זו שורה חד־פעמית, ויש למחוק אותה אחרי יום האירוע. QA 35/35.',
			'GH-824: שדות חדשים ב-Partner, לא חובה: contact_first_name, contact_last_name ו-contact_phone (הנייד נשמר בפורמט אחיד).',
			'GH-824: העלאות באשף מוגבלות לתמונות ו-PDF. כל סוג אחר מקבל 415. QA 57/57.',
			'GH-816: נמחק מ-index.ts בלוק AUTH_LOGIN שהיה בהערה.',
			'אתר שיווקי, GH-817: עמוד "תקציב wellbeing חכם" הוא עכשיו HTML עצמאי ב-S3, במקום Wix.',
			'אתר שיווקי, GH-818: בעמוד הבית באנגלית נוסף סקשן Smart Budget, עם קישור ל-wellbeing-en.',
			'אתר שיווקי, GH-820: תיקוני מובייל בעמוד הבית באנגלית: Book a demo מתחת לאיור, איורי פורמטים גדולים יותר ואייקונים קטנים יותר.',
			'הגשה: אנדרואיד 2.3.9 (versionCode 453) ממתינה לאישור של Google Play. השחרור מנוהל, ולכן אחרי האישור צריך ללחוץ "Publish changes".',
		],
		tickets: [
			['GH-825', 'מכבי: חישוב הציון לפי המסמך של מכבי + עדכון כל חצי שעה'],
			['GH-822', 'כרטיס חיבור השעון מופיע מיד אחרי אישור ההרשאה'],
			['GH-821', 'אתגר הצעדים: הוסר "עדיין לא זכאי/ת" מ"הקבוצה שלכם"'],
			['GH-823', 'יום אירוע Cellebrite: מומחה מוסתר ויומן רק לעובדי החברה'],
			['GH-824', 'ספקים: איש קשר לקשר שוטף, והעלאות רק של תמונות ו-PDF'],
			['GH-819', 'מכבי: גדלי היחידות מ-19.10'],
			['GH-817', 'עמוד "תקציב wellbeing חכם" כ-HTML עצמאי'],
			['GH-818', 'עמוד הבית באנגלית: סקשן Smart Budget'],
			['GH-820', 'אתר באנגלית: תיקוני מובייל'],
			['GH-816', 'ניקוי קוד: AUTH_LOGIN שבהערה'],
			['GH-828', 'עדכון "גרסאות — מה השתנה": סגירת 2.3.9 ופתיחת 2.4.0'],
		],
	},
	{
		version: '2.3.8',
		date: '2026-10-18',
		platforms: ['mobile', 'web', 'backend', 'admin'],
		users: [
			'צעדים מהשעון: אפשר לחבר את Apple Health (אייפון) או Health Connect (אנדרואיד), כך שגם צעדים משעון חכם (Apple Watch, Galaxy Watch, Fitbit, Garmin ועוד) ייספרו בתחרות ובאתגרי הצעדים. החיבור מכרטיס "הולכים עם שעון?" במסכי הצעדים, ורק בחברות שהדליקו את זה. כל יום נספר לפי הגבוה מבין הטלפון לבין Health, וצעדים שהוזנו ידנית לא נספרים.',
			'אחרי החיבור הכרטיס מראה "מחובר ל-Apple Health / Health Connect" ואת מספר הצעדים של היום ב-Health, שמתעדכן תוך כדי שהמסך פתוח.',
			'אתגר הצעדים האוטונומי (לא מכבי): לפני ההצטרפות יש תיבת אישור לתנאי השימוש ותקנון התחרות, עם הסבר שצריך להיכנס לאפליקציה לפחות פעם בשבוע ושהשם הפרטי ומספר הצעדים יוצגו לחברי הקבוצה.',
			'אתגר חבר: הדו־קרב מתחיל מהיום שאחרי האישור, ויש שקיפות לגבי הסבב הבא ושיא אישי.',
			'NaturalIntelligence — יום אירוע 10.11: עמוד מומחה של אלה מורדכייב ("שיחת הכוונה ארגונומיה משרדית", 10:30–17:00) עם יומן פתוח רק לעובדי החברה, באתר.',
			'מסך הסרטונים נטען מהר יותר: התשובה מהשרת ירדה מכ-5.5MB לכ-0.2MB.',
			'אנדרואיד 8 ומעלה בלבד (בגלל Health Connect). לפי Play אין משתמשים פעילים באנדרואיד 7.',
		],
		hr: [
			'מתג חדש בעמוד החברה: "ספירת צעדים מהשעון (Apple Health / Health Connect)". כבוי כברירת מחדל; דלוק במכבי. כיבוי אחרי שאנשים התחברו לא מוחק צעדים שכבר נספרו.',
			'מנהלת עסקית (business-admin) מקבלת את עמוד "שותפים": אישור ודחיית ספקים, לקוחות ארגוניים וטעינת תקציב ידנית.',
		],
		tech: [
			'שעון: @kingstinct/react-native-healthkit (iOS, קריאה בלבד, הרשאת HealthKit) ו-react-native-health-connect (אנדרואיד, READ_STEPS); minSdk 24 → 26; patch-package ל-nitro-modules. היום של Apple Health נקרא כ-statistics collection כדי שדגימה שחוצה חצות תתחלק לפי שעה כמו באפליקציית Health.',
			'לוג מקורות הצעדים (GH-812): step_source_daily (פירוק לכל יום: טלפון / Health / ידני / נשלח / מקורות) ו-health_store_connections (מצב חיבור והיסטוריה), שורת [health-steps] ב-CloudWatch בכל שינוי. רק רישום, אחרי התשובה.',
			'Company.health_store_steps_enabled (GH-813) נשלח לאפליקציה בהתחברות; כל סנכרון צעדים בודק אותו לפני קריאה מ-Health.',
			'אנדרואיד (GH-814): הקישור "מדיניות פרטיות" במסך ההרשאות של Health Connect פותח את grouphug.online/tnc (HealthPrivacyActivity), דרישה של Google.',
			'GH-811: thumbnail (base64) הוסר מתשובות הסרטונים למשתמשים; getPopularVideos מקבל את מזהי הקטגוריות משאילתה קלה.',
			'GH-802: StepChallengeParticipant.terms_accepted_at, לא חובה בשרת (גרסאות ישנות ממשיכות להצטרף כרגיל).',
			'GH-809: שורות אירוע (GH-712) מקבלות company אופציונלי; שורה חד־פעמית ל-NaturalIntelligence — למחוק אחרי 10.11.',
			'הגשה: App Store (App Privacy: Health + Fitness), Google Play (הצהרת Health apps).',
		],
		tickets: [
			['GH-813', 'מתג לכל חברה: ספירת צעדים מהשעון (Apple Health / Health Connect)'],
			['GH-812', 'לוג מקורות הצעדים בכל סנכרון'],
			['GH-814', 'אנדרואיד: הקישור למדיניות הפרטיות במסך ההרשאות של Health Connect'],
			['GH-811', 'ביצועים: מסך הסרטונים בלי התמונה המוטמעת'],
			['GH-802', 'תיבת אישור תנאים בהצטרפות לאתגר הצעדים (לא מכבי)'],
			['GH-778', 'אתגר חבר — השרת + הדו־קרב מתחיל מחר'],
			['GH-809', 'יום אירוע NaturalIntelligence 10.11'],
			['GH-810', 'מנהלת עסקית: גישה לעמוד "שותפים"'],
			['GH-815', 'עדכון "גרסאות — מה השתנה": סגירת 2.3.8 ופתיחת 2.3.9'],
		],
	},
	{
		version: '2.3.7',
		date: '2026-10-14',
		platforms: ['mobile', 'web', 'backend', 'admin'],
		users: [
			'מכבי — הרשמה עם טלפון: עוברים ישר למילוי הפרטים, בלי מסכי הפרטיות שלפני ההרשמה, ועם שורת אישור אחת מקוצרת.',
			'מכבי — "הרצאות" הפכו ל"אימונים" בכל מקום באפליקציה ובאתר (בעברית; למשל "אימונים מותאמים עבורך", "לכל האימונים", "הרשמה לאימון").',
			'מכבי — כרטיס חדש בעמוד הבית: "בוחרים את האימון שלכם!", והוסר משפט ההסבר הכללי מעמוד האימונים ומעמוד ה-VOD.',
			'הרשמה עם טלפון (כל החברות שנרשמים בהן בטלפון, כמו מכבי ו-CATO): שדה המייל נקרא "מייל פרטי (לא ארגוני)".',
			'אנדרואיד — כפתור "חזור" בעמוד הבית ובמסך הראשון של השאלון סוגר את האפליקציה, במקום להחזיר למסך הזנת הטלפון (זה מה שגרם ל"צריך להתחבר מחדש בכל יציאה").',
			'קוד הכניסה (OTP) באפליקציה, באתר ובאדמין הוא עכשיו בן 6 ספרות.',
		],
		hr: [
			'אתגר חבר (תחרות הצעדים האוטונומית) — באדמין: מתג הפעלה לכל חברה ואזור מעקב (מדדים ורשימת הזמנות) בעמוד התחרות. האפליקציה כבר כוללת את הכפתור, האתגר האישי והזמנות; השרת עוד לא עלה, והתכונה כבויה בכל החברות עד שמדליקים.',
		],
		tech: [
			'SOC2: קוד OTP בן 6 ספרות ממחולל קריפטוגרפי (crypto.randomInt), וגם קישורי איפוס הסיסמה; סיסמה חדשה — מינימום 8 תווים (עמוד האיפוס, יצירת מנוי באדמין, שלב 2 בהרשמת מומחה), בלי שינוי בדאטה-בייס.',
			'מכבי — "אימונים" ממומש כשכבת תרגום (constants/stepsOnlyCopy.ts) שחלה רק כשהחברה של המשתמש המחובר steps_only, ומשוחזרת אחרת; הדילוג על מסכי הפרטיות לפי הדגל skip_privacy_intro מהשרת.',
			'אתגר חבר: תבניות וואטסאפ (Twilio) בעברית ובאנגלית אושרו כ-Marketing; QA בשרת 287/287 על בסיס הטסט.',
			'QA: qa-gh806-otp-password.ts (24/24), qa-gh807-skip-privacy-intro.ts (10/10).',
		],
		tickets: [
			['GH-807', 'מכבי: הרשמה עם טלפון, "אימונים", "מייל פרטי (לא ארגוני)", תיקון "חזור" באנדרואיד'],
			['GH-806', 'SOC2: קוד OTP בן 6 ספרות + מינימום 8 תווים לסיסמה'],
			['GH-778', 'אתגר חבר: הזמנת עמית לתחרות הצעדים האוטונומית (אפליקציה + אדמין; השרת בהמשך)'],
			['GH-808', 'עדכון "גרסאות — מה השתנה": סגירת 2.3.7 ופתיחת 2.3.8'],
		],
	},
	{
		version: '2.3.6',
		date: '2026-10-13',
		platforms: ['mobile', 'web', 'backend', 'admin'],
		users: [
			'צעדים — ספירה חיה: כשמסך הצעדים פתוח המספר עולה תוך כדי הליכה, ואיתו הסה"כ, הממוצע וימי הפעילות (מכבי + אתגר הצעדים האוטונומי, אייפון ואנדרואיד). לשרת נשלח רק המספר הרשמי של הטלפון, כמו קודם.',
			'צעדים — הצעדים מתעדכנים בכל חזרה לאפליקציה מהרקע (בלי ההגבלה של 10 דקות), וגם אחרי סנכרון בעמודי התחרות.',
			'צעדים באייפון — יום ההצטרפות לתחרות נספר משעת ההצטרפות ולא מחצות (מכבי + אתגר אוטונומי), ובלי "קפיצה" של שנייה לצעדים מחצות ברגע ההצטרפות.',
			'כרטיסי הצעדים בבית כבר לא נעלמים ומופיעים מחדש כשחוזרים מעמוד התחרות: אחרי הטעינה הראשונה רק הנתונים מתעדכנים.',
			'מכבי — מי שלא נמצא ב-20 המובילים במחוז או ב-30 המובילים במכבי לא רואה את המיקום שלו בטבלה (קבוע בשרת, אפשר להחזיר).',
		],
		hr: [
			'תקציב חכם — "הקצאת הדגמה" בעמוד "מימושי תקציב חכם": שליחת הצעה אמיתית (כותרת A/B, שיחת היכרות) למנהלת לצורך הדגמה. מסומנת כהדגמה ולא נספרת בתקציב, בדוחות, ב-A/B או ב-HR.',
		],
		tech: [
			'יום ההצטרפות באייפון נשלט ממתג בהגדרות (steps_join_day_from_join_time), פעיל לכולם מ-13.10; ערך false מחזיר את ההתנהגות הקודמת.',
			'SHOW_RANK_OUTSIDE_TOP = false בשרת: מי שמחוץ לטבלאות מקבל rank_hidden ולא מיקום. בגרסאות אפליקציה ישנות יופיע "המקום שלכם יתעדכן בחישוב הבא" עד העדכון.',
			'QA: qa-gh804-live-steps.ts (28/28) לחוקי הספירה החיה; qa-gh767 עודכן לקבוע החדש (עובר בשני המצבים).',
		],
		tickets: [
			['GH-804', 'תחרויות צעדים: כרטיס בית יציב, הסתרת מיקום מחוץ לטבלאות, ספירת צעדים חיה'],
			['GH-803', 'צעדים באייפון: בלי "קפיצה" לצעדים מחצות ברגע ההצטרפות'],
			['GH-801', 'צעדים: סנכרון בכל חזרה לאפליקציה'],
			['GH-800', 'צעדים באייפון: יום ההצטרפות נספר משעת ההצטרפות'],
			['GH-796', 'סימולציית הקצאה להדגמה למנהלות'],
			['GH-805', 'עדכון "גרסאות — מה השתנה": סגירת 2.3.6 ופתיחת 2.3.7'],
		],
	},
	{
		version: '2.3.5',
		date: '2026-10-13',
		platforms: ['mobile', 'web', 'backend', 'admin', 'experts'],
		users: [
			'מכבי — תחרות היחידות: 92 יחידות ב-3 ליגות לפי גודל (עד 69 / 70–149 / 150+), "צועדי-על" (3 המובילים בחברה), ובעמוד התחרות "היחידה שלכם · ליגה · מקום N מתוך M".',
			'מכבי — שמות בדירוג רק בהסכמה: מסך הסכמה בהרשמה (מסומן מראש, אחרי בחירת היחידה) ומתג "הצגת השם בדירוג" בפרופיל; מי שלא אישר מופיע כ"משתתף אנונימי". הכרטיס והפופאפ בעמוד התחרות הוסרו.',
			'מכבי — נוסח: "מחוזות/מטה/יחידות סמך" בכל מקום, "היחידה" בהתראות, "שלוש היחידות המובילות בדירוג"; הפודיום מוצג פעם אחת למחוז; תוקן "דלג" בשאלון לפני פגישה.',
			'מכבי — מוסתרים רכיבים לא רלוונטיים: הטיפ היומי, "לא מוצאים מה שאתם צריכים?", "מה כלול במנוי?", ובפרופיל "התאמת תכנים אישית", "המפגשים שלי", "כתובת אימייל פרטית", "העדפות דייטינג" (באפליקציה גם "well-being").',
			'מכבי — בכרטיס התחרות בבית: עיגול מלא סביב "צעדים היום", בלי "מתוך 10,000"; בטבלת המחוזות הוסרה התגית שחתכה את שם המחוז (השורה שלכם מסומנת ברקע).',
			'מכבי — הדיסקליימר ומסך ההסכמה ממורכזים; הפס האדום של הרשאת הצעדים נעלם מיד אחרי האישור.',
			'אתגר הצעדים האוטונומי — עיגול "צעדים היום" בכרטיס הבית (בלי יעד); בכרטיס כבר לא מוצג מספר העמיתים שהצטרפו.',
			'צעדים — כרטיסי הצעדים בבית מתעדכנים מיד אחרי שהצעדים נשלחים לשרת, וגם כשחוזרים לאפליקציה מהרקע (לא יותר מפעם ב-10 דקות).',
			'אפליקציה — עברית מימין לשמאל כבר בפתיחה הראשונה (לא רק אחרי סגירה ופתיחה).',
			'אונבורדינג — אפשר לחזור אחורה ולשנות תשובות; תוקן תאריך הלידה שקפץ חזרה; שמירת תחומי עניין בפרופיל עובדת גם בלי סטטוס משפחתי.',
			'חיפוש AI — כל תוצאה מסומנת "מטפל/ת" או "מומחה/ית", ובחיפוש הראשי באתר המטפלים מופרדים; שמות מלאים.',
			'צ\'אט AI — חיפוש הרצאות (לפי נושא ותאריך), קישורי סרטונים שנפתחים באפליקציה, זמינות מומחים, רשימת נושאים ושאלות פתיחה אישיות.',
			'מיילים — כל סוגי המיילים נשלחים גם למייל הפרטי המאומת (לא רק תזכורות פגישה). באנר "הוסיפו מייל פרטי" בבית הוסר לכולם.',
			'מרחב בטוח — 2 שיחות היכרות בחצי שנה (גם ב-AppsFlyer), וחלון הספירה תוקן.',
			'eToro — שאלון "שאלות למומחה" אחרי קביעה בעמוד המומחה; ציטוט מלא בעמוד ליה אושרה; קרין טוקר עברה ל-19.11.',
			'שאלוני המשוב אחרי פגישת תקציב חזרו להיפתח באתר (web.grouphug.online).',
			'תקציב חכם — קמפיין "עדכון השאלון" ללקוחות קיימים: מייל + וואטסאפ עם magic link לסבב עדכון של שאלות האונבורדינג.',
		],
		hr: [
			'דשבורד תחרות הצעדים (מכבי) — ליגות וצועדי-על; בפירוט מחוז → יחידות: ציון לכל יחידה (אותו חישוב ואותו הסבר), "ליגה · מקום", מיון לפי ציון; במסך צר הנתונים בשתי שורות.',
			'מכבי — הרשאת "מובילת וולנס": רואה את דירוג המחוזות ואת המחוז שלה עם כל היחידות (בלי ליגות); מגדירים באדמין לפי טלפון, בעמוד התחרות.',
			'אדמין — "העבר לארכיון" למומחים ולמטפלים (עם אזהרה אם עדיין פעילים/מוצגים במנוי); הם יוצאים מכל הרשימות.',
			'אדמין — קביעת פגישה למנוי גם באותו יום (בלי מגבלת 12 השעות).',
			'אדמין — "היסטורית התחברות" בחברה: סיכום חודשי מהיר במקום טעינה של כל ההתחברויות (היה עד 100 שניות).',
			'אדמין — עמוד לעריכת הבאנר הראשי (כללי + לחברות) ופופאפ ההגרלה; איכות תמונה משופרת בהעלאה.',
			'אדמין — מסכים כבדים מהירים: סטטיסטיקות מנויים, רשימת פגישות, רשימת חברות; חיווי כמה עמיתים בפרטי תחרות.',
			'מומחים — בחירת יומני Google שחוסמים זמינות (גם תתי-יומנים), באזור המומחים.',
			'מומחים — בדף המידע: הסבר על כניסה לפגישות דרך הקישור של GroupHug; תזכורת 15 דק׳ לפני פגישה (מייל + וואטסאפ) הופעלה ב-12.10.',
			'"פופולרי בקרב אנשים שדומים לך" — כל הצגה ולחיצה נרשמות אצלנו (ליומן הפעילות) לצורך מדידה.',
		],
		tech: [
			'אבטחה (GH-794) — API המנויים: עריכת מנוי רק למנהלים; נסגרו נתיבים פתוחים (ספירה, יצירת מנוי, התראות, פגישות); פעולות לפי ID נקשרות למשתמש המחובר; תשובות האדמין בלי טוקנים/קודים/סיסמאות בכל עומק; סינון $ בגוף הבקשה וחסימת סינון לפי שדות סודיים; קוד ה-OTP לא נכתב ללוג; כשל לא צפוי בהרשמה נרשם עם הסיבה.',
			'SOC2 — דיפלוי לשרתים דרך SSM; פורט 22 נסגר לכל העולם (GH-785).',
			'כספת — הריצה הלילית עובדת עם ההרשאה של השרת (לא עם מפתחות ה-S3).',
			'לוג בקשות איטיות (מעל 3 שניות) — לאבחון התראות unhealthy-backend.',
			'מכבי — טבלה נפרדת לטלפונים מורשים (company_allowed_phones) + סקריפט ייבוא מ-CSV; פעילה כשהחברה עוברת ל"טלפון".',
			'אתגר הצעדים — סטטוס האתגר מחזיר את צעדי היום (today_steps).',
			'סקריפטים: maccabi-unit-leagues-setup, step-competition-reset-member, company-allowed-phones-import, QA לכל משימה (gh789/790/791/794/797).',
		],
		tickets: [
			['GH-756', 'שאלוני המשוב חזרו לאתר'],
			['GH-757', 'קמפיין "עדכון השאלון"'],
			['GH-758', 'עיצוב מייל "עדכון השאלון"'],
			['GH-759', 'לוג בקשות איטיות'],
			['GH-760', 'צ\'אט AI — הקשר עשיר'],
			['GH-761', 'מומחים — בחירת יומני Google'],
			['GH-762', 'מייל פרטי בכל המיילים'],
			['GH-763', 'שאילתות כבדות באדמין'],
			['GH-765', 'אתגר צעדים בלי מספר עמיתים + טעינת יומן'],
			['GH-766', 'באנר ראשי ופופאפ הגרלה באדמין'],
			['GH-767', 'מכבי — שמות בדירוג'],
			['GH-768', 'אונבורדינג — חזרה אחורה ותאריך לידה'],
			['GH-769', 'כספת — הרשאת השרת'],
			['GH-770', 'היסטורית התחברות באדמין'],
			['GH-774', 'קביעת פגישה באותו יום'],
			['GH-775', 'eToro — ציטוט + קרין ל-19.11'],
			['GH-776', 'שמירת תחומי עניין בפרופיל'],
			['GH-777', 'צ\'אט AI — הרצאות, סרטונים, זמינות'],
			['GH-780', 'מכבי — הסכמה להצגת שם בהרשמה'],
			['GH-782', 'חיפוש AI — מטפל/מומחה'],
			['GH-783', 'מכבי — נוסח, פודיום, "דלג"'],
			['GH-784', 'שיחות היכרות — 2 בחצי שנה'],
			['GH-785', 'SOC2 — דיפלוי דרך SSM'],
			['GH-786', 'eToro — שאלות למומחה'],
			['GH-788', 'מדידת לחיצות lookalike'],
			['GH-789', 'מכבי — מובילת וולנס'],
			['GH-790', 'מכבי — ליגות יחידות + צועדי-על'],
			['GH-791', 'ארכיון מומחים באדמין'],
			['GH-792', 'מומחים — הסבר על קישור GroupHug'],
			['GH-794', 'אבטחה — API המנויים'],
			['GH-795', 'מכבי — תיקוני נוסח ותצוגה + RTL'],
			['GH-797', 'מכבי — הרשמה בטלפון מרשימה'],
			['GH-798', 'מכבי — הסתרת רכיבים + צעדי היום'],
		],
	},
	{
		version: '2.3.4',
		date: '2026-10-05',
		platforms: ['mobile', 'web', 'backend', 'admin', 'experts'],
		users: [
			'תקציב חכם — שמות ואורכים חדשים לפגישות: "פגישת תמיכה / ייעוץ / אימון — ממוקדת (35 דק׳) / מלאה (50 דק׳) — עם מומחה" ("תמיכה" במקום "טיפול"). כל 35 השירותים עודכנו; פגישות שכבר נקבעו נשארו כמו שהן.',
			'תקציב חכם — A/B לכותרת ההצעה: חצי מהעובדים מקבלים "הוקצתה לך הטבה אישית…" וחצי "קיבלת הטבה ייחודית עבורך" (הגרלה אחת להצעה, בכל הערוצים).',
			'מכבי — דיסקליימר בתחילת ההרשמה בנוסח שמכבי אישרה; חייבים לאשר כדי להמשיך.',
			'חיפוש באפליקציה — הפרדה בין "מומחים" ל"מטפלים" בתוצאות (מטפלים לא מוצגים יותר כמומחים).',
			'מעגלי תמיכה — עיצוב חדש לכרטיס ולחדר (אפליקציה + אתר); תיקון שוליים בחדר באנדרואיד.',
			'אפליקציה — עמוד הבית בלי ספינרים ובלי "קופסאות ריקות" בזמן טעינה; כל חלק מופיע כשהוא מוכן, בלי אפקט כניסה.',
			'אנדרואיד — קישורים לעמודים ציבוריים (שאלוני משוב, קישור ההצעה של התקציב החכם) לא נבלעים יותר לתוך האפליקציה: האפליקציה נפתחת רק מהקישורים שיש להם מסך בתוכה (כמו ב-iOS), וכל קישור אחר נפתח בדפדפן.',
			'שאלוני המשוב (עובד ומומחה) אחרי פגישת תקציב מוגשים עכשיו ישירות מהשרת (api.grouphug.online) — נפתחים בדפדפן בכל מכשיר, גם למי שלא עדכן אפליקציה.',
			'פגישות אישיות — הקישור לפגישה בתזכורות (וואטסאפ, מייל, יומן) הוא קישור GroupHug שמעביר לזום; מבחינת העובד והמומחה נכנסים לפגישה בדיוק כמו קודם.',
			'פגישות אישיות — תוקן: פגישות שנקבעו לאותו יום לא קיבלו תזכורות בכלל (46 תזכורות ב-8 פגישות בשבועיים). עכשיו כל תזכורת נקבעת ברגע ההזמנה, ורשת ביטחון כל 5 דקות שולחת תזכורת שהתפספסה.',
			'אפליקציה — תוקנה קריסה באנדרואיד בגלילות (הוחלפה ספריית הקרוסלה).',
			'אתגר צעדים אוטונומי — הצעדים נספרים מיום ההצטרפות בלבד; השיפור = החצי השני של המחזור מול הראשון.',
			'eToro — אירוע נובמבר: לעובדי eToro נפתחת רק "שיחת הכוונה" (20 דק׳) של 4 המומחיות; עמוד מומחית ייעודי עם שעות יום האירוע; לשיקמה נחמן הפסקה של 5 דק׳ וסיום ב-16:50.',
			'פגישות עתידיות (תשלום 48 שעות לפני כל פגישה) — נפתח ליוליה רובינזון; טופס התשלום נשלח גם בוואטסאפ (תבנית מאושרת), בנוסף למייל ולפוש.',
			'אתר — הרשמה לחברה באנגלית: פוטר מעודכן עם תנאי פרטיות.',
		],
		hr: [
			'תקציב חכם — משוב מומחה: אחרי פגישת תקציב המומחה מקבל 6 שאלות קצרות; רק אחרי שענה הוא רואה מה העובד כתב. באדמין שני המשובים זה לצד זה.',
			'תקציב חכם — תוקן מסנן הבטיחות של נימוק ה-HR שהפיל משפטים תקינים לנוסח הקבוע אצל חלק מהמומחים (שתי הקצאות Optival נכתבו מחדש).',
			'אדמין — תפקידים: "תמיכה טכנית" (מומחים, מעגלים, הרצאות, בנק שירותים, VOD, שיתופים מהאונבורדינג) ו"מנהלת עסקית" (חברות + תקציב החברה, מנויים, מומחים, הרצאות). יוליה הועברה לתמיכה טכנית.',
			'אדמין — עמוד חדש "מאגר מומחים לאירועים": סינון לפי התמחות, מגדר וסוג; מיון לפי דירוג עובדים (12 חודשים), דירוג הרצאות, מספר הרצאות, ממוצע נרשמים להרצאה ופגישות ב-90 יום; ייצוא לאקסל.',
			'אדמין — חיפוש מומחים לפי מייל ומנויים לפי טלפון (גם 7 ספרות אחרונות); איתור מבקש DSR לפי טלפון.',
			'אדמין — רשימות המומחים והמטפלים: עמודת "הצטרפות" עם מיון.',
			'אדמין — הרצאות וסדנאות: שדה "עד תאריך" לצד "מתאריך".',
			'אדמין — חברה: דיסקליימר לחברה (מתג + נוסח בעברית ובאנגלית), נערך מהאדמין. נוסף תרגום לאנגלית ל-5 חברות.',
			'אדמין — כפתורי הדייטינג הוסרו מהסרגל העליון.',
			'פגישות אישיות — כשעובד קובע פגישה עם מומחה שאין לו קישור זום במערכת, אורי וקרן מקבלים מייל.',
		],
		tech: [
			'כספת (vault) — פיילוט member_notes: tokenize בכתיבה וקריאה דרך הכספת; כבוי עד שיוגדרו משתני הסביבה בפרוד.',
			'family_relationship חזר להיות שדה טקסט פתוח (enum נעל משתמשי Bluevine מחוץ להרשמה, 23.9).',
			'SOC2 — בדיקת תהליך שינוי (GH-738); סקירה בדיעבד של שינויים שעלו בלי PR נפתחה ב-GH-748.',
			'סקריפטים: update-wellness-session-names (שמות/אורכים), qa-future-appointments-e2e-mail, resend-step2-email.',
			'"מי לא נכנס לפגישה" (GH-753, שלב א׳): כל לחיצה על קישור פגישה נרשמת (sessionjoinevents: צד, מקור, זמן יחסית לפגישה); מנוע התראות במצב צל — רושם מה היה עושה ולא שולח כלום; שלב ב׳ (ההתראות עצמן) ב-GH-752 אחרי שבועיים של נתונים. מתג כיבוי: policy.SESSION_JOIN_LINKS_ENABLED.',
			'תזכורת למומחה 15 דק׳ לפני פגישה (מייל + וואטסאפ) — בנויה, עולה כבויה (EXPERT_T15_REMINDER_ENABLED=false) עד שקרן תשקף למומחים.',
			'אנדרואיד — intentFilters ב-app.json מצומצמים ל-16 הנתיבים של ה-AASA; מסך דיפ-לינק חדש = לעדכן deepLinks.ts + AASA + app.json.',
		],
		tickets: [
			['GH-716', 'eToro — שיחת הכוונה בלבד'],
			['GH-720', 'eToro — עמוד מומחית ייעודי'],
			['GH-721', 'כספת — פיילוט member_notes'],
			['GH-722', 'עדכון תנאי פרטיות (פוטר)'],
			['GH-723', 'איתור מבקש DSR לפי טלפון'],
			['GH-724', 'תפקיד מוגבל ליוליה באדמין'],
			['GH-725', 'הסתרת כפתורי הדייטינג באדמין'],
			['GH-727', 'A/B לכותרת הצעת התקציב'],
			['GH-728', 'חיפוש באדמין לפי מייל וטלפון'],
			['GH-730', 'משוב מומחה אחרי פגישת תקציב'],
			['GH-731', 'עיצוב מעגלי תמיכה'],
			['GH-733', 'קריסת אנדרואיד — החלפת הקרוסלה'],
			['GH-734', 'הפרדת מומחים ומטפלים בחיפוש'],
			['GH-735', 'הרשאות באדמין'],
			['GH-736', 'הרצאות — "עד תאריך"'],
			['GH-737', 'תמיכה טכנית — שיתופים מהאונבורדינג'],
			['GH-738', 'בדיקת תהליך SOC'],
			['GH-739', 'נימוק HR — מסנן הבטיחות'],
			['GH-740', 'מכבי — דיסקליימר בהרשמה'],
			['GH-741', 'עמוד הבית בלי ספינרים'],
			['GH-742', 'eToro — שעת סיום לשיקמה'],
			['GH-743', 'שמות ואורכים לפגישות התקציב'],
			['GH-744', 'עמודת הצטרפות + רשימת מטפלים'],
			['GH-745', 'עמוד הבית בלי fade'],
			['GH-747', 'פגישות עתידיות — יוליה + וואטסאפ'],
			['GH-749', 'מאגר מומחים לאירועים'],
			['GH-753', 'קישורי פגישה מתווכים + תיקון תזכורות + מצב צל'],
			['GH-755', 'אנדרואיד בולע קישורים ציבוריים — שאלונים מה-API + נתיבים ייעודיים'],
		],
	},
	{
		version: '2.3.3',
		date: '2026-09-23',
		platforms: ['mobile', 'web', 'backend', 'admin'],
		users: [
			'מעגלי תמיכה (חדש): שיחת וידאו/אודיו קבוצתית בהנחיית מומחה סביב נושא, בתוך האפליקציה והאתר. כרטיס "מעגלי תמיכה" בעמוד הבית עם המעגל הקרוב, הרשמה, חדר עם מנחה. מעגלים באודיו בלבד (בלי מצלמות) — כולם רואים את כולם ברשימה עם "בחדר · N"; כפתור המצלמה מוסתר כשאין מצלמה.',
			'מעגלי תמיכה: המנחה רואה בזמן אמת "הערות המשקיף" — סוכן AI שמאזין למעגל ומסמן למנחה מצוקה, קונפליקט או שקט ממושך (ההתראות רק למנחה; המשתתפים רואים הודעת שקיפות בתחילת המעגל).',
			'HR (מנהלות): "מצב המענה האישי עכשיו" — באנר בעמוד הבית (מחליף את הציטוט היומי) + עמוד מלא: סטטוס (ירוק/צהוב/אדום), מדד אימפקט, עובדים שקיבלו הקצאות ממוקדות / בתהליך התאמה / % מהתקציב, המענים האחרונים ("מענה לעובד.ת 12345: שיחת טיפול ממוקדת", "אימפקט לפי העובד.ת 5/5" או "ממתין למשוב"), תקציב שנתי, מפגשים בחודש הקרוב, תמונת צורך, ו"לכל ההקצאות" עם סינון. כפתור "רענון נתונים" (פעם בדקה) + "עודכן לפני X דק׳". מוצג רק כשיש לפחות 2 קביעות.',
			'HR: פוש "תקציב ה-Wellbeing בפעולה" בכל פעם שעובד/ת קובע/ת פגישה מהתקציב (בלי פרטים מזהים).',
			'גלובל — ניוזלטר: משתמש גלובלי חדש רואה פעם אחת, לפני עמוד הבית, שאלה אם לקבל את הניוזלטר; "כן" מצרף אותו לקבוצה בActiveTrail. גלובליים לא נכנסים יותר ל-ActiveTrail בהרשמה.',
			'גלובל — טופס התשלום של PayMe באנגלית למשתמשים גלובליים.',
			'עמוד הפרסים באתר: אותו לואדר כמו באפליקציה (מתנה קופצת + פס התקדמות) בכניסה הראשונה.',
			'מכבי (תחרות צעדים): מסך הפרטים האחרונים באונבורדינג כבר לא שואל מצב משפחתי ו"יש לך ילדים?" — נשארו רק "מחוז / מטה / יחידת סמך" ו"יחידה ארגונית".',
			'אתגר צעדים אוטונומי — הופעל לראשונה (משטרת ישראל, 23.9): מחזור 14 יום, הזמנות בפוש, ומי שעל גרסה ישנה מקבל במייל "חברים שלך הצטרפו לתחרות הצעדים…" עם כפתורי החנויות (הנוסח של אודי). המייל תמיד במייל (לא בפוש), עד 500 ביום לחברה, לכל מי שנכנס אי פעם (לא רק 90 יום).',
		],
		hr: [
			'אתר — טבלת ההקצאות ל-HR: "מהות ההקצאה", סטטוס "התקבל ונקבע" (תכלת) עד שהפגישה מתקיימת, כותרות משנה תחת "מדד האימפקט" ו"משוב שהתקבל", ציטוט משוב עד 3 שורות + "עוד", כפתור רענון מעל הטבלה.',
			'נימוק ההקצאה ל-HR: נכתב מחדש על ידי GPT מהנימוק הפנימי (הפרומט של אודי) — משפט מדויק לצורך, שונה בין עובדים (רשימת "אל תחזור על אלה" של אותה חברה), רק אחרי שנקבעה פגישה, עם פילטר בטיחות שפוסל שמות/משפחה/אבחנות/מספרים ונופל לנוסח הקבוע. הנימוקים הקיימים של המשטרה נכתבו מחדש.',
			'אזור המומחים + אדמין: "טווחי חופשות" — כמה טווחי חופשה למומחה (במקום אחד), רשימה עם מחיקה; האדמין רואה ועורך את אותה רשימה בכרטיס המומחה.',
			'מייל למומחה "נקבעה פגישה חדשה / עודכנה": בפגישות תקציב מוצג גם משך הפגישה (30 / 50 דק׳).',
			'אדמין — פרסים: התראה במייל לטרא כשנשארו ≤5 קודים חופשיים בפרס (פעם אחת, מתאפס כשמוסיפים קודים).',
			'אדמין — חברה: "פרסים לחברה" (ריק = כל הפרסים) — חברי החברה רואים רק את הפרסים שנבחרו (מכבי: 5 פרסים, כולל Otentik עם 20 קודים).',
			'אדמין — ניהול תקציב: עמוד "כל ההצעות" עם ספירות לפי סטטוס (בהמתנה / התקבלו / פקעו).',
			'אדמין — מעגלי תמיכה: יצירה/עריכה (נושא, מנחה, מועד, אודיו בלבד, חברות מוחרגות, קהל יעד: מגדר/הורות/שפות/מצב משפחתי/מטפלים בהורים), "סוכן משקיף", ותמלול: סיכום + דגלים + תמליל נקי לייצוא (נשמר 60 יום).',
			'אדמין — VOD: העלאת וידאו ישירות מהדפדפן ל-S3 (עד 400MB, פס התקדמות אמיתי) — ההעלאה כבר לא עוברת דרך השרת ולא מאיטה אותו.',
			'eToro — אירוע נובמבר: ארבע מומחיות (אנאיס אזולאי 23.11, שיקמה נחמן 24.11, ליה אושרה 18.11, קרין טוקר 30.11) פתוחות ביום האירוע 09:30–17:30 רק לעובדי eToro; לכל השאר היום סגור. + עמוד אירוע באתר. חד-פעמי, יוסר אחרי 30.11.',
			'HR Pulse — סנאפשוט: הנתונים מחושבים ברקע (מימוש/ביטול/משוב/קרון 11:00) ונקראים במילישניות; חישוב שנכשל לא משפיע על המשתמש.',
		],
		tech: [
			'LiveKit (Cloud, Build): SupportCircle/SupportCircleTranscript (TTL 60 יום), טוקנים עם canPublishSources לאודיו בלבד, AgentDispatch למשקיף; ריפו חדש grouphug-agent (LiveKit Agents JS + OpenAI realtime STT + gpt-5.2 brain, data channel agent-flag) בקונטיינר Docker על grouphug-testing; נקודות שירות עם x-agent-key.',
			'HrPulseSnapshot (fire-and-forget, 45s timeout, debounce 20s, סריאליזציה פר חברה); notifyHrOfBooking; Company.prizes; Instructor.vacations[] (בלי מיגרציה, לצד vacation הישן); Member.newsletter_consent + ACTIVE_TRAIL_GLOBAL_NEWSLETTER_GROUP_ID; POST /vod/:id/upload-url + upload-complete (presigned POST, CORS על grouphug-bucket ל-admin בלבד); generateHrReasonForHr חזר למסלול + HR_NOTE_FORBIDDEN; אתגר צעדים: NUDGE_ONLY_IF_LOGGED_IN_DAYS=1000, runUpdateNudges במייל בלבד, Msg.lines; ETORO_EVENT_BLOCKS ב-instructor.service.',
			'סקריפטים: regenerate-hr-notes-booked, cancel-no-show-session (ביטול שקט + החזרת תקציב), resend-offer-notifications, scan-app-versions-by-company, set-company-prizes, add-coupons-to-prize.',
			'תשתית (SOC2, 23.9): GuardDuty ב-Frankfurt + N. Virginia → SNS security-alerts → מייל; SSH לפרוד רק דרך EC2 Instance Connect; הצפנת EBS כברירת מחדל; Atlas Network Access 16 → 4 כתובות.',
		],
		tickets: [
			['GH-660', 'נימוק ההקצאה ל-HR — הפרומט החדש'],
			['GH-662', 'אתגר צעדים אוטונומי — הפעלה במשטרה'],
			['GH-691', 'VOD — העלאה ישירה ל-S3'],
			['GH-696', 'ניוזלטר למשתמשים גלובליים'],
			['GH-697', 'אדמין — כל הצעות התקציב'],
			['GH-704', 'מעגלי תמיכה'],
			['GH-705', 'התראת מלאי נמוך בפרסים'],
			['GH-706', 'HR Live Pulse באפליקציה'],
			['GH-707', 'טווחי חופשות למומחה'],
			['GH-708', 'מעגלים — סבב 1 (אודיו, קהל יעד, החרגות)'],
			['GH-709', 'סוכן AI משקיף במעגלים'],
			['GH-711', 'פרסים לחברה (מכבי)'],
			['GH-712', 'eToro — 4 מומחיות בנובמבר'],
			['GH-713', 'eToro — עמוד אירוע'],
			['GH-714', 'משך הפגישה במייל למומחה'],
		],
	},
	{
		version: '2.3.2',
		date: '2026-09-15',
		platforms: ['mobile', 'web', 'backend', 'admin'],
		users: [
			'מכבי — אונבורדינג מקוצר: בורר "מחוז / מטה / יחידת סמך" ו"יחידה ארגונית" (במקום "מחוז / מרחב"), בלי תאריך לידה, תפקיד ניהולי וותק; אחרי מסך הפרטים מסיימים ישר לבית — בלי תחומי עניין ובלי שאלון (הבוסטים נוצרים אוטומטית).',
			'מכבי — בפרופיל: במקום "המחלקה בארגון" כרטיס "היחידה שלך בארגון" עם אותם בוררים, ממולא לפי הבחירה, ואפשר לשנות.',
			'מסך "כמה פרטים אחרונים": לואדר עד שידוע איזו גרסת טופס להציג (במקום קפיצה של השדות).',
			'הרשמה בלי מייל מאומת: מעבר למסך קוד האימות עם הודעה ברורה (במקום קריסה "failed to store token").',
			'כרטיס הפרגון באנגלית: החצים של הקרוסלה לפי הצד הנכון.',
			'מכבי — הסרגל "ההתקדמות שלי / להטבה הבאה" (הבוסטים) לא מוצג לחברות במדיניות נקודות "צעדים בלבד".',
			'עמוד הפרסים: כל הפרסים מוצגים בקטגוריות — גם נעולים (מעומעם + מנעול), במקום שורת "פרסים נעולים" נפרדת; בתחתית רק "פרסים שמימשתי" (ורק כשיש). הודעת "No prizes to show" הוסרה.',
			'גלובל — מחירים ותשלום בדולרים: משתמש גלובלי רואה $ בכל מקום (שירותים, קביעה, הרצאה, lifestyle) ומחויב ב-PayMe בדולרים. ישראלים ללא שינוי.',
			'גלובל — מסך הקביעה: המשבצות מחולקות לימים לפי אזור הזמן של המשתמש (לא לפי יום ישראלי); הימים המודגשים בלוח לפי אותו חישוב.',
			'גלובל — פרסים: הסליידרים (פופולריים, קטגוריות, מימשתי) נגללים משמאל לימין באנגלית, וכרטיס בודד נצמד לשמאל; הצ\'יפים באותו כיוון.',
			'גלובל — סרגלי טעינה (פרסים, אתגרים, סטורי) מתמלאים משמאל לימין באנגלית.',
			'אונבורדינג: מסך הביניים "עכשיו, לשאלון ממש קצר…" חזר בין תחומי העניין לשאלה הראשונה (הוסר ב-19.8). הטקסט נערך בהגדרות האונבורדינג באדמין.',
			'גלובל — טקסטים: "Preparing your subscription…", "Online" במקום "Online session option", מסך 1:1 בלי הסוגריים על עזרה ראשונה רגשית.',
			'מומחים גלובליים: "Online" מוצג בכרטיס במקום ריבוע ריק (הסימון מסונכרן אוטומטית מהשירותים).',
		],
		hr: [
			'אדמין — חברה: "טקסט פתיחה לאונבורדינג" (עברית / אנגלית) פר חברה; ריק = הטקסט הכללי. מוצג במסך הפתיחה בלי שינוי באפליקציה.',
			'דשבורד תחרות הצעדים ב-HR: הכותרת "פרסי המשנה" → "טאגים מיוחדים".',
			'פאלו אלטו: נמחקו 1,928 מיילים מאושרים של חברות כבויות; מייל מאושר מאפשר הרשמה רק לחברה פעילה.',
			'אזור המומחים + אדמין: "הפסקה בין פגישות" למומחה (0–180 דק\') — מרווח מינימלי לפני ואחרי כל פגישה, כולל אירועי יומן גוגל שעד עכשיו לא קיבלו מרווח. 0 = כמו קודם.',
			'אדמין — חברה: "קטגוריות בוסטים לחברה" — הבוסטים השבועיים נבחרים רק מהקטגוריות שנבחרו (מכבי = פיטנס); כשהמאגר נגמר חוזרים על בוסטים. ריק = הכל כרגיל.',
			'אדמין — חברה: "הסתר עבור חברות" על הרצאה חל עכשיו גם על כרטיסי ההרצאות בעמוד הבית (עבד רק ברשימת ההרצאות).',
			'אדמין — ניהול תקציב: הצעה חכמה פגה בסוף היום האחרון (23:59) ולא בשעת השליחה; "ימים שנותרו" בתזכורת ובעמוד ההטבה בימים קלנדריים. + הצעה מחדש להצעה שפגה (סקריפט/נקודת אדמין).',
			'אדמין — מומחה: "מקבל אונליין" מוצג גם למומחים גלובליים.',
			'גלובל — תוכן: 26 סרטוני VOD חדשים (5 קטגוריות, כולל Relationships & Dating), 20 פרקי פודקאסט (Parenting, Women\'s Health), 13 פרסי NowYouKnow, 2 הרצאות באנגלית ו-3 הרצאות לנובמבר.',
			'מייל מימוש פרס: קוד הקופון חזר למייל. מייל הרשמה להרצאה למשתמש גלובלי מציג את השעה באזור הזמן שלו.',
		],
		tech: [
			'סיום אונבורדינג עם ?skip_survey=1 יוצר תוכנית בוסטים אם אין; נתיב היחידות מחזיר גם my_unit / my_parent_unit.',
			'PayMe: generate-sale מקבל currency לפי is_global של המשלם; Payment.currency (ILS/USD, לא חובה, ברירת מחדל ILS).',
			'זמינות: חלון היום של מומחה עם אזור זמן מחושב בשעון שלו (getDailyFreeSlots dayStartOverride) — לפני כן דלפו משבצות בין חצות ישראל לחצות שלו.',
			'Instructor.break_between_sessions; PUT /instructor/admin/profile-break; Instructor.is_online מסונכרן מהשירותים למומחים גלובליים; Company.boosts_categories; SignupBonus (נקודות בהרשמה לפי מייל); reoffer endpoint; getMemberAgesQuery משווה מזהה חברה (לא אובייקט) ו-hide_for.members.',
		],
		tickets: [
			['GH-664', 'מכבי — תחרות הצעדים (אונבורדינג ופרופיל)'],
			['GH-695', 'גלובל — תיקוני טרה (סבב 1)'],
			['GH-698', 'קוד קופון במייל מימוש פרס'],
			['GH-700', 'הפסקה בין פגישות למומחה (תמר אפלמן)'],
			['GH-701', 'עמוד הפרסים — נעולים בתוך הקטגוריות'],
			['GH-702', 'גלובל — דולרים (תצוגה + PayMe)'],
			['GH-703', 'גלובל — תיקוני טרה (סבב 2)'],
		],
	},
	{
		version: '2.3.1',
		date: '2026-09-10',
		platforms: ['mobile', 'web', 'backend', 'admin'],
		users: [
			'אתגר צעדים אוטונומי (חדש) — בחברות שהפעילו: מחזורי תחרות של 14 יום בקבוצות קטנות של ~8 עמיתים, דירוג לפי ממוצע צעדים יומי, פרסים למקומות 1–3 ולשיפור הגדול ביותר, נקודה לכל 1,000 צעדים, תגי הישגים (100/200/500 אלף צעדים, זכיות, התמדה). הזמנה בפוש או במייל, הצטרפות מהכרטיס בעמוד הבית או מסוף האונבורדינג. מי שעל גרסה ישנה מקבל הודעה "עדכנו כדי להצטרף".',
			'צעדים → נקודות (מכבי): כל 1,000 צעדים בתחרות = נקודה למימוש בחנות הפרסים.',
			'תחרות הצעדים של מכבי: לוגו הקמפיין בכרטיס, סימון "היחידה שלי" בטבלה, תגי הישגים אישיים, תזכורת "אל תאבדו את הצעדים" אחרי 5 ימים בלי סנכרון.',
			'דירוג האפליקציה בחנויות: בקשת דירוג אחרי חוויה חיובית.',
			'משוב אחרי פגישת wellbeing (תקציב): שאלון חדש (גרסה 2) עם סולמות מנוסחים.',
			'מסך הכניסה: "הזדהות באמצעות טלפון / אימייל החברה / האימייל אליו נשלחה הזמנה להצטרפות".',
			'מומחים ומטפלים: מומחה שנכנס לאפליקציה לא רואה תכני מנוי; מייל למנוי כשמומחה קובע איתו פגישה.',
			'משוב אחרי פגישת wellbeing: מי שלא ענה מקבל תזכורת אחת במייל ובוואטסאפ 48 שעות אחרי הפגישה.',
			'מומחה יכול לקבוע למנוי פגישה ראשונה לפי כתובת המייל שלו (בלי שהמנוי יזום), והמנוי מקבל מייל אישור. לא בפגישות תקציב.',
			'הצהרת בריאות: חידוש אחת לשנה (אתר ואפליקציה).',
			'פודקאסט (חדש): טאב שלישי במסך התוכן עם פרקי אודיו, מחולק לקטגוריות, נגן עם דילוג 15 שניות שממשיך לנגן גם כשהמסך נעול. הטאב מופיע רק למי שיש לו פרקים.',
			'גלובל — עמוד הבית: הגלילות באנגלית רצות משמאל לימין; כותרת "What should I do today?"; טקסטים חדשים לכרטיסי "מה לעשות היום" (בן משפחה, הרצאות, שאלות קצרות, פרגון) בנוסח שאושר; כפתור לכל כרטיס לפי הכרטיס (Invite / Register / Start).',
			'גלובל — פרסים: אייקון הפרסים ובאנר הנקודות חזרו למשתמשים גלובליים.',
			'גלובל — באנר "More in GroupHug" חדש (award zone) שמוביל להרצאות.',
			'גלובל — "You may like" ב-VOD חזר להמלצות מותאמות אישית (במקום רשימה קבועה), לכולם.',
			'גלובל — הרשמה: שני צ\'קבוקסים בלבד — תנאי שימוש (עמוד אנגלי) והסכמה לשימוש במידע רגיש/בריאותי עם קישור למדיניות הפרטיות הגלובלית.',
			'גלובל — אזור זמן: רשימת צפון אמריקה בניסוח האמריקאי (Eastern / Central / Mountain / Pacific…).',
			'גלובל — שדה החיפוש בבחירת מדינה משמאל לימין; כרטיס הפרגון באנגלית: איור משמאל וטקסט מימין, כפתור מוצמד לשמאל.',
			'מומחים גלובליים: שם מלא (פרטי + משפחה) במקום שם אחד.',
		],
		hr: [
			'תקציב Wellbeing אדפטיבי: מודל הקצאה חדש (Top 12%, סולם עד 3 טיפולים), נימוק HR לכל הקצאה, המשכים אדפטיביים. חי במשטרה.',
			'ספקים / שותפים: צד הספק מקצה לקצה (אתר, אשף הצטרפות, OTP, דשבורד, הזמנות) + התחלת צד ה-HR/קונה.',
			'דשבורד תחרות הצעדים (מכבי) ב-HR: ללא פס ניווט צדדי, החץ מחזיר לעמוד הבית.',
			'אדמין: "אתגר צעדים אוטונומי" — הפעלה לחברה + דשבורד מעקב (pool, מחזורים, הזמנות, הצטרפויות).',
			'אדמין: "אימות זהות" — שליחת קוד חד-פעמי למי שמבקש למחוק/לקבל את המידע שלו, עם יומן ביקורת (SOC2).',
			'אדמין: "גרסאות — מה השתנה" — העמוד הזה.',
			'אדמין: עריכת פגישות; כרטיס הערות אונבורדינג אקראיות בדף הבית; חיפוש קבוע בדף החברות; סדר תצוגת פרסים.',
			'HR — ניהול תקציב: עמודת "תאריך המענה" (מתי המנוי ענה להצעה) בדף התקציב ובאדמין.',
			'אדמין — סיכום מפגשים פרטניים: כפתור "עדכון לגבי תשלום" ששולח לכל מומחה עם תשלום בחודש מייל "תשלום בסך X עבור חודש Y עבר לביצוע", עם תצוגה מקדימה וסימון מי כבר קיבל.',
			'אדמין — ניהול תקציב: סימון "לא השאיר משוב · תזכורת נשלחה", שעת הפגישה בטבלה, הסתרת משוב כפול.',
			'אדמין — פגישות פרטניות: סינון לפי מומחה כולל מומחים פעילים שאינם במנוי.',
			'ספקים / שותפים: ארנק תקציב נפרד לכל חברה, טעינת תקציב בסליקת PayMe עם תשלומים, טעינה ידנית מהאדמין, עמודת "תקציב" ו"הוזמן על ידי", עסקאות חיצוניות לא מורידות מהתקציב, התראות על ספק/ארגון חדש גם לדולב.',
			'גלובל: 14 מומחים גלובליים חדשים פורסמו ושויכו לקטגוריות.',
			'אדמין — פודקאסטים: אזור חדש ליצירת פרקים, העלאת mp3 (עד 200MB, האורך נקרא אוטומטית), קטגוריות פודקאסט (סוג חדש בקטגוריות VOD), סימון גלובלי.',
			'אדמין — VOD: צ\'קבוקס "גלובלי" גם ביצירת סרטון וביצירת קטגוריה; רשימת הקטגוריות בסרטון מציגה רק זמינות; תיקון השגיאה אחרי יצירת קטגוריה.',
			'תחומי עניין גלובליים: 7 תחומים חדשים (סקריפט, הורץ בפרוד).',
		],
		tech: [
			'חברות במצב "נקודות רק מצעדים" (מכבי): נקודות רק מהתחרות, עמוד בית רזה, החיפוש לא מציג מומחים/מטפלים.',
			'עמלת wellness: 3% → 8%.',
			'מיילי תחרות/אתגר: הסרה בלחיצה אחת; קוד OTP בוואטסאפ בתבנית Utility.',
			'SOC2: Verify workflow ב-CI, סקירת גישות; שמות לא נשלחים ל-OpenAI.',
			'אימות זהות (SOC2): קוד הוואטסאפ עבר לתבנית OTP מאושרת.',
			'התראת "השיא האישי" בתחרות הצעדים כוללת את התאריך של היום המוצלח.',
			'טופס ההצטרפות האנגלי למומחים שומר שם מלא בשני שדות השם; סקריפט תיקון לשמות הקיימים.',
			'הרשמה: שדה אופציונלי sensitive_data_consent על המנוי (נשמר רק אם נשלח, גרסאות ישנות לא מושפעות).',
			'ישות podcast באוסף המדיה (discriminator), נתיבי /podcasts, העלאה ל-S3 תחת podcasts/<id>/.',
			'עמוד מדיניות פרטיות גלובלי (HTML סטטי) מוכן להעלאה.',
		],
		tickets: [
			['GH-662', 'יצירת אתגר צעדים אוטונומי לחברה'],
			['GH-671', 'צעדים → נקודות (תחרות הליכה)'],
			['GH-664', 'מכבי שירותי רפואה — תחרות הצעדים'],
			['GH-674', 'תיקוני תקציב אדפטיבי'],
			['GH-670', 'מודל הקצאה אדפטיבי לתקציב Wellbeing'],
			['GH-660', 'טקסט תיאורי לסיבת הקצאת תקציב'],
			['GH-676', 'התחלת בניית ספקים'],
			['GH-680', 'המשך ספקים'],
			['GH-591', 'בקשת דירוג בחנויות אחרי חוויה חיובית'],
			['GH-667', 'עדכון משוב אחרי פגישות הקצאת תקציב'],
			['GH-666', 'עריכת פגישות מהאדמין'],
			['GH-652', 'הערות אונבורדינג בדף הבית של האדמין'],
			['GH-654', 'הגדרות כניסה לאפליקציה של מומחים/מטפלים'],
			['GH-655', 'מייל למנוי כשמומחה קובע פגישה'],
			['GH-645', 'סדר הופעת פרסים'],
			['GH-634', 'חיפוש קבוע בדף החברות באדמין'],
			['GH-679', 'אימות זהות לבקשות מחיקה/קבלת מידע'],
			['GH-681', 'תיאור מה התעדכן בכל גרסה'],
			['GH-686', 'סינון מומחים בפגישות פרטניות + צד ה-HR בשוק הספקים'],
			['GH-687', 'פרסום מומחים גלובליים'],
			['GH-688', 'פגישה ראשונה לפי מייל המנוי'],
			['GH-689', 'הצהרת בריאות — חידוש שנתי'],
			['GH-693', 'תזכורת משוב אחרי פגישה'],
			['GH-694', 'עדכון לגבי תשלום למומחים'],
			['GH-695', 'תיקונים — גלובל'],
		],
	},
	// ===== שוחזר בדיעבד (4.10.2026) =====
	// שלושת הבלוקים הבאים נכתבו בדיעבד מתוך היסטוריית ה-git (merges לענף הראשי בכל הריפואים) ו-Jira.
	// באותה תקופה לא נוהלו מספרי גרסאות — המספר משוער, והתאריך הוא תאריך ה-merge האחרון בתקופה.
	{
		version: '2.2.3',
		date: '2026-08-06',
		platforms: ['mobile', 'web', 'backend', 'admin'],
		users: [
			'תקציב חכם — עמוד "magic link": לחיצה על ההצעה במייל או בוואטסאפ פותחת עמוד שבו קובעים פגישה עם המומחה המתאים בלי להתחבר ובמינימום קליקים; עיצוב חדש לעמוד לפי Figma.',
			'"בשבילך" (פניות פרואקטיביות) — מנגנון שמציע לכל משתמש תכנים רלוונטיים ללא עלות (VOD, הרצאות, בוסטים) לפי תמונת הצורך שלו, ועמוד "בשבילך" באפליקציה ובאתר.',
			'בוסטים — סוג חדש של בוסט אנכי בסגנון reels, לצד הבוסטים הרגילים.',
			'גלובל — בחירת מדינה בהרשמה ותיקוני תצוגה למשתמשים גלובליים.',
		],
		hr: [
			'אדמין — התערבויות פרואקטיביות: לוג של ההצעות שנשלחו + סינון והגדרות.',
			'אדמין — ניהול תקציב: שיפורים בעמוד (כמה עדכונים קטנים).',
		],
		tech: [
			'תיקוני טקסט במיילים, תיקון וואטסאפ, שדה מגדר, שאלות נוספות באונבורדינג.',
		],
		tickets: [
			['GH-637', 'פניות פרואקטיביות לפי דירוג צרכים'],
			['GH-656', 'פניות פרואקטיביות — עיצוב + QA'],
			['GH-643', 'בוסטים אנכיים (reels)'],
			['GH-644', 'עמוד magic link להצעת התקציב'],
			['GH-646', 'עמוד magic link — עיצוב'],
			['GH-651', 'גלובל — משימות אפליקציה'],
		],
	},
	{
		version: '2.2.2',
		date: '2026-07-21',
		platforms: ['mobile', 'web', 'backend', 'admin'],
		users: [
			'אזור אתגרים (חדש) — אתגרים באפליקציה ובאתר עם ספירת צעדים מהטלפון, ודשבורד ניהול ל-HR (הדגמה למכבי).',
			'פרסים — עיצוב חדש לעמוד הפרסים עם קטגוריות; פרסי התוכנית נשארו בראש העמוד.',
			'Dream — עובד יכול לבקש בעילום שם עוד שיחת הכוונה, ו-HR מאשר או דוחה במייל.',
			'Bluevine — אימות זהות לבן משפחה שמצטרף.',
			'פרגון — הודעה אוטומטית לחברים יום אחרי השקה של חברה או הצטרפות של חברה חדשה.',
			'תקציב חכם — נוסח חדש להצעה (פחות "ספאמי", יותר דגש על פרטיות).',
		],
		hr: [
			'אדמין — ניהול תקציב: עדכונים בעמוד.',
			'אדמין — הגדרות פרסים ומיילים שנשלחים בעת מימוש.',
		],
		tech: [
			'פרומפט חדש להתאמת מומחים בתקציב; תיקוני תקציב קטנים.',
		],
		tickets: [
			['GH-623', 'פרגון אוטומטי בהשקת חברה'],
			['GH-628', 'פרסים — עיצוב חדש'],
			['GH-631', 'Bluevine — אימות זהות בן משפחה'],
			['GH-632', 'Dream — בקשת שיחת הכוונה נוספת'],
			['GH-635', 'נוסח הצעת התקציב'],
			['GH-638', 'אזור אתגרים — משתמש + HR'],
		],
	},
	{
		version: '2.2.1',
		date: '2026-06-09',
		platforms: ['mobile', 'web', 'backend', 'admin', 'experts'],
		users: [
			'פרגון בוואטסאפ למי שעוד לא מנוי — מפרגנים לעמית לפי טלפון, הוא מקבל הזמנה בוואטסאפ, והפרגון מחכה לו כשהוא נרשם.',
			'פגישות עתידיות — מומחה יכול לקבוע למטופל כמה פגישות קדימה; התשלום נדחה, וטופס תשלום נשלח 48 שעות לפני כל פגישה. המנוי רואה "ממתין לתשלום" ב"הפגישות שלי". (נבנה ונבדק; נפתח בפועל רק למומחים נבחרים)',
		],
		hr: [
			'אדמין — חברה: "התחברות גם בטלפון" לחברה שנכנסת במייל ארגוני, עם רשימת טלפונים מורשים (Polyram).',
			'אדמין — חברה: בוסטים בלי שאלון אונבורדינג (skip_onboarding_questions).',
			'תקציב חכם — סבב תיקונים במנוע ובמסכים (GH-621).',
		],
		tech: [
			'Company.allow_phone_login + allowed_phones; תשתית פגישות עתידיות (is_future, קרון שעתי לבקשות תשלום וביטול אוטומטי).',
		],
		tickets: [
			['GH-539', 'פגישות עתידיות באזור המטפלים'],
			['GH-618', 'פרגון בוואטסאפ למי שאינו מנוי'],
			['GH-621', 'תיקוני תקציב'],
			['GH-625', 'פגישות עתידיות — QA + פרונט'],
		],
	},
];
